import React from 'react';

export const MCSAOnboarding = () => {
    return (
        <iframe
            title="Onboarding"
            src="/mcsa_htmls__TBD/onboarding.html"
            style={{
                position: 'fixed',
                inset: 0,
                width: '100%',
                height: '100%',
                border: 'none',
            }}
        />
    );
};
